// JavaScript Document

//splash
$(function () {
  // スプラッシュの最小表示時間（ms）
  const MIN_SPLASH_TIME = 1000; // ← ここを1秒に
  // フェードアウトなどのアニメ時間（ms）
  const HIDE_ANIM_DURATION = 600;

  // 計測開始（できるだけ早いタイミングで評価）
  const splashStart = performance.now();

  // DOMが準備できたら処理
  $(function () {
    const splash = document.getElementById('splash');
    if (!splash) return;

    // 実際にスプラッシュを消す処理
    function hideSplash() {
      splash.classList.add('hide'); // CSSでopacity/transformのトランジション
      setTimeout(() => {
        splash.style.display = 'none';
      }, HIDE_ANIM_DURATION);
    }

    // 最小表示時間を満たすまで待つ
    const now = performance.now();
    const elapsed = now - splashStart; // ms
    const wait = Math.max(0, MIN_SPLASH_TIME - elapsed);

    // 速く終わった場合は wait > 0 だけ余分に待つ
    setTimeout(hideSplash, wait);
  });

  // 参考：window.loadで制御したい場合（画像等の読み込み完了に合わせる）
  // window.addEventListener('load', () => {
  //   // 上の $(function(){ ... }) 内のロジックをここに移せば、
  //   // 画像読み込みまで含めて最小1秒表示にできます。
  // });
  });

  //ハンバーガーメニュー
$(function () {
  // 共通：全メニューを閉じる
  function closeAllMenus() {
    // ハンバーガー
    $('#nav-input').prop('checked', false);
    $('#nav-open').removeClass('active');

    // ハンバーガー内アコーディオン（必要なら閉じる）
    $('.hamburger-sp__title, .hamburger-sp__sub-ttl').removeClass('js-rotate');
    $('.hamburger-sp__sub-menus, .hamburger-sp__sub-box').slideUp(0);

    // PCメガメニュー
    $('.header-itemlist__item').removeClass('--active');
    $('.drop-container').removeClass('drop-open');
  }

  // ハンバーガー開閉（既存ロジックを踏襲）
$('#nav-open').off('click.nav').on('click.nav', function (e) {
  e.preventDefault();    // 追加：labelのforによるinput自動クリックを止める
  e.stopPropagation();   // 外側閉じへの伝播抑止

  const $self = $(this);
  const willActive = !$self.hasClass('active');

  // 状態を一元管理
  $self.toggleClass('active', willActive);
  $('#nav-input').prop('checked', willActive);
});

  $('#nav-close').on('click', function () {
    closeAllMenus();
  });

  // ハンバーガー内の同一ページアンカーをクリックしたら閉じる（元の処理＋堅牢化）
  $('#nav-content a[href^="#"]').on('click', function () {
    closeAllMenus();
  });

  /* ハンバーガー内アコーディオン（元のまま） */
  $('.hamburger-sp__title').click(function () {
    $(this).toggleClass('js-rotate');
    $(this).next('.hamburger-sp__sub-menus').slideToggle();
  });

  $('.hamburger-sp__sub-ttl').click(function () {
    $(this).toggleClass('js-rotate');
    $(this).next('.hamburger-sp__sub-box').slideToggle();
  });


  // メガメニューの制御（元コードを踏襲しつつ、アンカークリックで閉じるを追加）
  // ドロップダウンメニューの開閉処理
  $('.hasDropdown').click(function (e) {
    e.preventDefault(); // 開閉専用のまま
    var parentMenu = $(this).closest('.header-itemlist__item');
    var isActive = parentMenu.hasClass('--active');

    // すべてのメニューを閉じる
    $('.header-itemlist__item').removeClass('--active');
    $('.drop-container').removeClass('drop-open');

    // クリックされたメニューのみ開く
    if (!isActive) {
      parentMenu.addClass('--active');
      parentMenu.find('.drop-container').addClass('drop-open');
    }
  });

  // noDropdown要素のクリック：閉じる（元の意図を維持）
  $('.noDropdown').click(function () {
    closeAllMenus();
  });

  // ドロップダウン内のリンクをクリックしたら閉じる（同一ページアンカー含む）
  $('.drop-container a').on('click', function () {
    closeAllMenus();
  });

  // メニュー外のクリックで閉じる（元の処理を closeAllMenus に置き換え）
$(document).off('click.navdoc').on('click.navdoc', function (e) {
  if (!$(e.target).closest('.header-itemlist__item, #nav-open, #nav-content').length) {
    closeAllMenus();
  }
});

  // ハッシュが変わったとき（同一ページアンカー遷移時）も閉じる
  $(window).on('hashchange', function () {
    closeAllMenus();
  });

$(function() { // DOMContentLoaded
  function toggleHeaderFixed() {
    var scroll = $(window).scrollTop() || 0;
    $('.pc-header').toggleClass('header-fixed', scroll >= 100);
    $('.sp-header').toggleClass('header-sp-fixed', scroll >= 60);
  }

  function init() {
    $(window).off('scroll.toggleHeaderFixed')
             .on('scroll.toggleHeaderFixed', toggleHeaderFixed);
    toggleHeaderFixed();
  }

  init();

  // bfcache復元対応
  $(window).on('pageshow', function() {
    init();
  });
});

 (function () {
    // トップページか判定（.visual-picがあるときだけ）
    const visual = document.querySelector('.visual-pic');
    const header = document.querySelector('.pc-header');
    if (!visual || !header) return;

    // 監視用の分岐点（.visual-pic の直後に1pxの要素を置く）
    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:relative;width:100%;height:1px;';
    visual.insertAdjacentElement('afterend', sentinel);

    // ヘッダーに inversion を付与/除去
    const setInversion = (on) => {
      header.classList.toggle('inversion', !!on);
    };

    // IntersectionObserverで、sentinelがビューポート内に見えているかで判定
    const io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        // ルート（ビューポート）と交差していない＝.visual-pic を通過して上にスクロールした状態
        // → inversion を付与
        setInversion(!e.isIntersecting);
      },
      {
        root: null,          // ビューポート
        rootMargin: '0px',
        threshold: 0         // 1pxでも見えたら intersecting
      }
    );

    io.observe(sentinel);

    // 初期状態の整合性（読み込み位置が途中の場合）
    // すでに .visual-pic を通過しているなら inversion 付与
    const rect = sentinel.getBoundingClientRect();
    if (rect.top <= 0) setInversion(true);

    // ページ離脱などでクリーンアップしたい場合
    window.addEventListener('beforeunload', () => io.disconnect());
  })();


if (window.innerWidth > 767) {
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 200) {
      //上から200pxスクロールしたら
      $("#page-top").removeClass("DownMove");
      $("#page-top").addClass("UpMove");
    } else {
      if ($("#page-top").hasClass("UpMove")) {
        $("#page-top").removeClass("UpMove");
        $("#page-top").addClass("DownMove");
      }
    }
  });
}



  //side-scroll
  new ScrollHint(".js-scrollable", {
    scrollHintIconAppendClass: "scroll-hint-icon-white",
    suggestiveShadow: true,
    i18n: {
      scrollable: "スクロールできます",
    },
  });

  //マウスドラッグスクロール
  jQuery.prototype.mousedragscrollable = function () {
    $(this).each(function () {
      let $target = $(this);
      $target.mousedown(function (event) {
        event.preventDefault();
        $target.data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $target.scrollLeft(),
          scrolltop: $target.scrollTop(),
        });
        // ドキュメントにmousemove, mouseupをバインド
        $(document).on('mousemove.mousedrag', function (event) {
          if ($target.data("down")) {
            event.preventDefault();
            let move_x = $target.data("x") - event.clientX;
            let move_y = $target.data("y") - event.clientY;
            if (move_x !== 0 || move_y !== 0) {
              $target.data("move", true);
            } else {
              return;
            }
            $target.scrollLeft($target.data("scrollleft") + move_x);
            $target.scrollTop($target.data("scrolltop") + move_y);
            return false;
          }
        }).on('mouseup.mousedrag', function () {
          $target.data("down", false);
          // イベントの解除
          $(document).off('.mousedrag');
          return false;
        });
        return false;
      });
      $target.click(function () {
        if ($target.data("move")) {
          $target.data("move", false);
          return false;
        }
      });
    });
  };
$(".side-scroll").mousedragscrollable();

});



// タブ
document.addEventListener("DOMContentLoaded", function () {
  const tabList = document.querySelectorAll(".tab-list-item");
  const tabContent = document.querySelectorAll(".tab-contents-item");

  for (let i = 0; i < tabList.length; i++) {
    tabList[i].addEventListener("click", tabSwitch);
  }

  function tabSwitch() {
    // すべてのタブからactiveを外す
    tabList.forEach(tab => tab.classList.remove("active"));
    // クリックしたタブにactiveをつける
    this.classList.add("active");

    // すべてのタブコンテンツからshowを外す
    tabContent.forEach(content => content.classList.remove("show"));
    // 該当するコンテンツにshowをつける
    const index = Array.prototype.indexOf.call(tabList, this);
    tabContent[index].classList.add("show");
  }
});

//アコーディオン

$(".accordion-content .ac-header").click(function () {
  $(this).next(".ac-inner").slideToggle();
  $(this).toggleClass("open");
});


//swiper
$(function () {
  const swiper = new Swiper(".visualswiper", {
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 4000,
      stopOnLastSlide: "false",
      disableOnInteraction: false,
    },
    speed: 2000,
    allowTouchMove: false,
  });
});

$(function () {
  const swiper2 = new Swiper(".workswiper", {
    loop: true,
  speed: 600, 
  slidesPerView: 1, 
  spaceBetween: 20 , 
  autoplay: {
    delay: 4000,
    stopOnLastSlide: "false",
    disableOnInteraction: false,
  },
  breakpoints: {
    601: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    
    1601: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1921: {
      slidesPerView: 5,
      spaceBetween: 40,
    },
    
  },
  });
});




//アンカー調整
$(function () {
       const additionalMargin = 20;

    // ヘッダーの高さ取得
    const getHeaderHeight = () => {
        if (window.innerWidth <= 1024) {
            return 60;
        }
        return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-pc_h')) || 135;
    };

    // フラグでhashchangeの二重発火を抑制
    let isManualScroll = false;

    // ページロード時のみアンカー調整
    $(window).on("load", function() {
        if (window.location.hash) {
            scrollToAnchor(window.location.hash);
        }
    });

    // スムーススクロール関数
    function scrollToAnchor(hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
            const rect = targetElement.getBoundingClientRect();
            const offsetTop = rect.top + window.pageYOffset - getHeaderHeight() - additionalMargin;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }

    // クリック時
    $('a[href^="#"]').on("click", function(e) {
        const href = $(this).attr("href");
        if (href.length > 1) {
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                e.preventDefault();
                isManualScroll = true;
                scrollToAnchor("#" + targetId);
                history.pushState(null, null, "#" + targetId);
                setTimeout(() => { isManualScroll = false; }, 100);
            }
        }
    });

    // hashchange時
    $(window).on("hashchange", function() {
        if (!isManualScroll) {
            scrollToAnchor(window.location.hash);
        }
    });
});

$(function () {
 // Intersection Observer で .reveal 要素を監視
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // 一度表示したら監視を外す（パフォーマンスと意図した挙動のため）
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // 10%入ったら表示
    });

    // 対象要素を登録
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

});